export default function QuebraCrenca() {
  const sinais = [
    { icon: 'ri-fire-line', label: 'irritação' },
    { icon: 'ri-mental-health-line', label: 'inquietação' },
    { icon: 'ri-question-mark', label: 'confusão' },
    { icon: 'ri-shield-cross-line', label: 'resistência' },
  ];

  return (
    <section className="py-12 sm:py-20 bg-gray-900 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          {/* Coluna Esquerda - Texto */}
          <div className="space-y-7">
            <div className="space-y-4">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight">
                Crises no Alzheimer quase nunca{' '}
                <span className="text-teal-400">aparecem do nada</span>
              </h2>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
                Antes da crise acontecer, o cérebro já está mostrando sinais:
              </p>
            </div>

            {/* Sinais em grid */}
            <div className="grid grid-cols-2 gap-3">
              {sinais.map((sinal, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white/10 border border-white/10 rounded-xl py-4 px-4"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-500/20 text-teal-400 flex-shrink-0">
                    <i className={`${sinal.icon} text-lg`}></i>
                  </div>
                  <span className="text-white font-medium text-sm sm:text-base">{sinal.label}</span>
                </div>
              ))}
            </div>

            {/* Fechamento */}
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-1 min-h-[44px] bg-teal-400 rounded-full flex-shrink-0 mt-1"></div>
                <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
                  O problema é que muitas famílias só percebem quando a crise{' '}
                  <strong className="text-white">já começou.</strong>
                </p>
              </div>
              <div className="bg-teal-600 rounded-2xl px-5 sm:px-7 py-5 text-white">
                <p className="text-base sm:text-lg leading-relaxed">
                  Quando você aprende a reconhecer esses sinais e entender o que está por trás do comportamento,{' '}
                  <strong>muitas situações deixam de escalar.</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Coluna Direita - Foto */}
          <div className="relative mt-6 lg:mt-0">
            <div className="relative w-full h-[260px] sm:h-[360px] lg:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/bc131c18f7a9ac090e11a1f9d53ce2e0.jpg"
                alt="Cuidador com paciente Alzheimer"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
